import Simple from "../../../Components/InputFields/Simple";
import PassWord from "../../../Components/InputFields/PassWord";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import Divider from "./Divider";
import SimpleButton from "../../../Components/Buttons/Simple";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTicketCount } from "../../../Context/TicketCountContext";
import { API_BASE_URL } from "../../../config/api";
export default function ContainerSignIn({ text, type }) {
  const [isDark, setIsDark] = useState(
    typeof document !== "undefined" &&
      document.documentElement.classList.contains("dark"),
  );
  const logoSrc = isDark ? LogoWhite10 : LogoBlue;
  const navigate = useNavigate();
  const { fetchTicketCount } = useTicketCount();
  const [signinData, setSigninData] = useState({
    email: "",
    password: "",
  });
  const [fieldsRequired, setFieldsRequired] = useState(false);
  const [invalidData, setInvalidData] = useState(false);

  const handleEmailChange = (e) => {
    setSigninData({ ...signinData, email: e.target.value });
    setFieldsRequired(false);
    setInvalidData(false);
  };
  const handlePasswordChange = (e) => {
    setSigninData({ ...signinData, password: e.target.value });
    setFieldsRequired(false);
    setInvalidData(false);
  };

  const handleSignin = async (e) => {
    e.preventDefault();
    // Handle sign-in logic here
    if (signinData.email === "" || signinData.password === "") {
      setFieldsRequired(true);
      return;
    }
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/login/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: signinData.email,
            username: signinData.email,
            password: signinData.password,
          }),
        },
      );

      const result = await response.json();

      if (response.status === 401 || response.status === 400) {
        setInvalidData(true);
        return;
      }

      // Check if server responded with error status
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      localStorage.setItem("refresh", result.refresh);
      localStorage.setItem("access", result.access);
      localStorage.setItem("role", result.role);
      localStorage.setItem("email", result.email);
      fetchTicketCount();
      navigate("/dashboard");
    } catch (error) {
      console.error("POST request failed:", error);
      return null; // or throw error again if you want
    }
  };

  return (
    <div className="w-full max-w-md bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5 m-4 gap-7 flex flex-col border border-zi-blue-light">
      <div className="flex flex-col gap-2 justify-center items-center">
        <img src={logoSrc} alt="لوگو" className="w-14" />
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
        {text}
      </h1>
      <div>
        <form className="flex flex-col gap-5">
          <Simple
            placeholder="آدرس ایمیل"
            type="email"
            id="email"
            formValue={signinData.email}
            formOnChange={handleEmailChange}
          />
          <div className="flex flex-col gap-1 items-end">
            <PassWord
              placeholder="رمز عبور"
              id="password"
              formValue={signinData.password}
              formOnChange={handlePasswordChange}
            />
            <a className="text-zi-blue-light text-xs hocus:underline">
              رمز عبور خود را فراموش کرده‌اید؟
            </a>
          </div>
          <GradientBlue type="submit" value="ورود" onClick={handleSignin} />
        </form>
        {fieldsRequired && (
          <p className="text-red-500 text-sm">لطفا تمامی فیلدها را پر کنید</p>
        )}
        {invalidData && (
          <p className="text-red-500 text-sm">
            ایمیل یا رمز عبور وارد شده صحیح نمی‌باشد
          </p>
        )}
      </div>
    </div>
  );
}
